import { render, staticRenderFns } from "./sys_column.vue?vue&type=template&id=85d3c664&"
import script from "./sys_column.vue?vue&type=script&lang=js&"
export * from "./sys_column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports